
import request from '@/utils/request'
import { ENABLE_API_DBG } from "@/appConfig.js";

function list (params) {
  const {max, offset, ...rest} = params;
  const newParams = {take: max, skip: offset, ...rest};
  const qsParams = new URLSearchParams();
  for (let [key, value] of Object.entries(newParams)) {
    qsParams.append(key, value);
  }
  //console.log(`api.user.list: qsParams = ${qsParams.toString()}`);
  const url = `/user?${qsParams.toString()}`;
  ENABLE_API_DBG &&
    console.log(`api.user.list: url = ${JSON.stringify(url)}`);
  return request({
    url,
    method: 'get',
    data: params
  })
}
function get (itemId) {
  return request({
    url: `/user/${itemId}`,
    method: 'get'
  })
}
function getWithTags (itemId) {
  return request({
    url: `/user/${itemId}?relation=tags`,
    method: 'get'
  })
}
function getWithGroups (itemId) {
  return request({
    url: `/user/${itemId}?relation=groups`,
    method: 'get'
  })
}
function availability (params) {
  const qsParams = new URLSearchParams();
  qsParams.append('username', params);
  return request({
    url: `/user/availability?${qsParams.toString()}`,
    method: 'get',
  })
}
function add (params) {
  return request({
    url: `/user`,
    method: 'post',
    data: params
  })
}
function update (params) {
  return request({
    url: `/user/${params.id}`,
    method: 'patch',
    data: params
  })
}
function resetPwd (params) {
  return request({
    url: `/user/resetPwd`,
    method: 'post',
    data: params
  })
}
function remove (itemId) {
  return request({
    url: `/user/${itemId}`,
    method: 'delete'
  })
}
export default {
  list,
  add,
  update,
  remove,
  get,
  getWithTags,
  getWithGroups,
  availability,
  resetPwd
}
